import { X } from "lucide-react";
import { memo } from "react";

import {
  DialogClose,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";

import type { IGlobalSearchHeaderProps } from "./types";

// NOTE: NSAI-6853 — the search box is the header: the input runs the full
// width beside a single close control, and the dialog title is only read out
// by assistive tech. Test ids kept from the SearchChats dialog this palette
// grew out of.
const GlobalSearchHeaderComponent = ({
  title,
  description,
  closeLabel,
  children,
}: IGlobalSearchHeaderProps): JSX.Element => (
  <div
    className="flex items-center gap-2 px-3 pt-3 sm:px-4"
    data-testid="search-chats-header"
  >
    <DialogTitle className="sr-only">{title}</DialogTitle>
    <DialogDescription className="sr-only">{description}</DialogDescription>
    <div className="min-w-0 flex-1">{children}</div>
    <DialogClose
      data-testid="search-chats-close"
      className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-foreground-secondary transition-colors hover:bg-glass-fill-strong hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <X className="h-5 w-5" />
      <span className="sr-only">{closeLabel}</span>
    </DialogClose>
  </div>
);

export const GlobalSearchHeader = memo(GlobalSearchHeaderComponent);
